import { render, staticRenderFns } from "./addStaffAppAuth.vue?vue&type=template&id=6b2dff1c&scoped=true"
import script from "./addStaffAppAuth.vue?vue&type=script&lang=js"
export * from "./addStaffAppAuth.vue?vue&type=script&lang=js"
import style0 from "./addStaffAppAuth.vue?vue&type=style&index=0&id=6b2dff1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2dff1c",
  null
  
)

export default component.exports